// extracted by mini-css-extract-plugin
export var label = "_dx-5";
export var slideContainer = "_dx-0";
export var slider = "_dx-1";
export var sliderLg = "_dx-4";
export var sliderMd = "_dx-3";
export var sliderSm = "_dx-2";